import type { ListResult } from '@lombok/shared';

/** The API caps a page at 100 (`listQuerySchema`), so lists that need everything ask for that. */
export const ALL_PAGES_SIZE = 100;

/** Safety stop so a runaway cursor can never loop forever (20 pages = 2,000 rows). */
export const ALL_PAGES_MAX = 20;

/**
 * Read every page of a cursor-paginated list: keeps asking for the next page until the API
 * stops returning `nextCursor` (or the safety cap is hit). Returns just the combined rows.
 */
export async function fetchAllPages<T>(
  fetchPage: (cursor: string | undefined) => Promise<ListResult<T>>,
  maxPages = ALL_PAGES_MAX,
): Promise<{ items: T[] }> {
  const items: T[] = [];
  let cursor: string | undefined;
  for (let page = 0; page < maxPages; page += 1) {
    const res = await fetchPage(cursor);
    items.push(...res.items);
    cursor = res.nextCursor;
    if (!cursor) break;
  }
  return { items };
}
